import React, { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import classes from "./SideDrawer.module.css";
import { withAuthentication } from "../../../hoc/withAuthentication";
import { activebar, home, logout, sideBarData } from "./SidebarIcons";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import Confirmation from "@/custom_components/Confirmation";
import { useEmployeeMode } from "@/components/Employee/useEmployeeCode";
import ProtectedImage from "@/custom_components/ProtectedImage";
const SideDrawer = ({ user, httpClient, hide = false, merchantInfo }) => {
  const { width } = useWindowDimensions();
  const shopId = user.selectedShop;
  const shop = user.storesData.find(({ _id }) => _id == shopId);
  const show = user.type !== "Vendor";
  const path = window.location.pathname;
  const sideCollapsed = user.sidebar.isCollapsed;
  const [confirm, setconfirm] = useState(false);
  const { signoutEmployee } = useEmployeeMode();

  const navBurgerClickHandler = () => {
    if (width <= 768) {
      user.setCollapseSideBar(true);
    } else {
      user.setCollapseSideBar(!sideCollapsed);
    }
  };
  useEffect(() => {
    if (width <= 768) {
      user.setCollapseSideBar(true);
    }
  }, [width]);
  return (
    <React.Fragment>
      <aside
        uk-height-viewport="expand: true"
        id="sideDrawer"
        className={[classes.leftCol, sideCollapsed ? "sideActive" : "", "uk-background-default"].join(" ")}
        style={{
          minHeight: sideCollapsed ? "100vh" : "calc(100vh - 25px)", // Adjust the height based on scrollbar width
          // overflowY: "auto", // Always show the scrollbar
          zIndex: 2, // Ensure the sidebar is rendered above other elements
        }}
      >
        <div
          className={[classes.aside_logo_div, "uk-text-center uk-position-relative "].join(" ")}
          style={{ backgroundColor: "#fff" }}
        >
          <a href="https://web.spotspos.com" target="_blank" rel="noopener noreferrer">
            <ProtectedImage
              src={shop?.storeLogoImg ? shop?.storeLogoImg : `/icons/header/profile_logo.svg`}
              alt="Store logo"
              className="uk-preserve-width uk-margin-horizontal logo"
              width={sideCollapsed ? "50" : "100"}
            />
            {/* <img
              className="uk-preserve-width uk-margin-horizontal logo"
              src={shop?.storeLogoImg ? shop?.storeLogoImg : `/icons/header/profile_logo.svg`}
              // src={   sideCollapsed ? `/icons/header/profile_logo.svg` : `/icons/header/logo-large.svg`}
              width={sideCollapsed ? "50" : "100"}
              alt="logo"
            /> */}
          </a>
          <span onClick={navBurgerClickHandler} className={[classes.collapse_icon, "pointer"].join(" ")}>
            <img
              style={{ width: sideCollapsed ? "22px" : "" }}
              className="uk-svg "
              src={sideCollapsed ? "/icons/header/collapsed-open.svg" : "/icons/header/collapsed.svg"}
            />
          </span>
        </div>
        {hide ? null : (
          <React.Fragment>
            <div
              style={{ overflowY: "auto", height: "78vh", overflowX: "hidden" }}
              className={"uk-background-default uk-padding-small"}
            >
              <ul className="uk-nav uk-nav-default uk-nav-parent-icon " uk-nav={1}>
                <li
                  className={`uk-position-relative uk-width-1-1 uk-background-default uk-margin-small  ${
                    path === "/" && "active"
                  }`}
                >
                  {path === "/" && (
                    <p width={sideCollapsed ? 3 : 4} className="uk-position-center-left">
                      {" "}
                      {activebar()}{" "}
                    </p>
                  )}
                  <Link to="/">
                    {home({ fill: path === "/" ? "var(--primary-color)" : "var(--black-color)", class: "" })}
                    <span className="uk-text-bold  color-black uk-margin-small-left ">
                      {(!show && " Purchase Order") || " Home"}
                    </span>
                  </Link>
                </li>
                {!!user.email && (
                  <React.Fragment>
                    {show && (
                      <React.Fragment>
                        {sideBarData({
                          isAppointment: shop && !/^free$/i.test(shop.plan),
                          isManageShops: /^(Admin|StoreAdmin)$/i.test(user.type),
                          path,
                          isRepair: !user.isRetail,
                        })?.map((item, indx) => {
                          if (/invoice/i.test(item?.title) && !merchantInfo.payrixMerchantId) {
                            return null;
                          }

                          return (
                            <li
                              key={"key_" + indx}
                              className={`${
                                !sideCollapsed && item?.hasChild && "uk-parent"
                              } uk-position-relative  uk-background-default uk-margin-small `}
                            >
                              {item?.isActive() && !item?.hasChild && (
                                <p width={sideCollapsed ? 3 : 4} className="uk-position-center-left">
                                  {" "}
                                  {activebar()}{" "}
                                </p>
                              )}
                              {item?.hasAnchorTag || item?.hasChild ? (
                                <>
                                  <a className={`${item?.isActive() && "active"}`} href={item?.url}>
                                    {item?.icon()}
                                    <span className="uk-text-bold  color-black uk-margin-small-left">
                                      {" "}
                                      {item?.title}
                                    </span>
                                  </a>
                                  {item?.childs && (
                                    <ul
                                      className="uk-nav-sub "
                                      style={{
                                        paddingLeft: "0px",
                                        borderLeft: "5px solid rgba(255,255,255,.5)",
                                      }}
                                    >
                                      {item?.childs?.map((sub_item, i) => (
                                        <li
                                          key={"sub_" + i}
                                          className={`uk-background-default uk-margin-small-minus uk-position-relative  ${
                                            sub_item?.isActive() && "active"
                                          }`}
                                        >
                                          {sub_item?.isActive() && (
                                            <p width={sideCollapsed ? 3 : 4} className="uk-position-center-left">
                                              {" "}
                                              {activebar()}{" "}
                                            </p>
                                          )}
                                          <Link className="sub_link uk-text-bold  color-black" to={sub_item?.url}>
                                            {sub_item?.icon()}
                                            {sub_item?.title}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </>
                              ) : (
                                <Link className={`${item?.isActive() && "active"}`} to={item?.url}>
                                  {item?.icon()}
                                  <span className="uk-text-bold  color-black uk-margin-small-left"> {item?.title}</span>
                                </Link>
                              )}
                            </li>
                          );
                        })}
                        <li
                          style={{ paddingBottom: "40px" }}
                          className={`uk-margin-large-top uk-background-default ${path === "/logout" && "active"}`}
                        >
                          <a onClick={() => setconfirm(true)}>
                            {logout({
                              fill: path === "/logout" ? "var(--primary-color)" : "var(--black-color)",
                              class: "",
                            })}
                            <span className="uk-text-bold uk-text-danger uk-margin-small-left ">{"Logout"}</span>
                          </a>
                        </li>
                        {confirm && (
                          <Confirmation
                            message={"Are you sure you would like to logout?"}
                            proceedLabel={"Logout"}
                            onCancel={() => setconfirm(false)}
                            onProceed={() => {
                              signoutEmployee();
                              window.location.href = "/logout";
                            }}
                          />
                        )}
                      </React.Fragment>
                    )}

                    {/* {/PTPR/i.test(user.referalCode) && (
                          <li className={`uk-background-default uk-margin-small`}>
                            <a target="_blank" href={"https://shop.repairspots.com/password"}>
                              <i className="uk-icon-link" uk-icon="icon: server;"></i>
                              <span>Comprar Piezas</span>
                            </a>
                          </li>
                        )} */}
                  </React.Fragment>
                )}
              </ul>
            </div>
          </React.Fragment>
        )}
      </aside>
    </React.Fragment>
  );
};

export default withAuthentication(SideDrawer);
